import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStudentAuth } from "../context/StudentAuthContext";

export default function RequireStudent() {
  const { isAuthenticated } = useStudentAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/student/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
